import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Navmenu from './header/Navmenu';
import { AppBar, Container } from '@mui/material';
import PaymentFields from './components/PaymentFields';
import reducer from './components/store';
import { injectReducer } from './redux/store';
import PaymentFieldsOthers from './components/PaymentBoxes/PaymentFieldsOthers';
import { useDispatch, useSelector } from 'react-redux';
import { getData } from './services/fetch-service';
import {
  setInstitucionet,
  //  setLlojiPagesesKesco, 
  setLlojiPagesesManualet,
  setManualetLlojiPagesesLoad,
} from './components/store/dataslice';
// import CameraViewer from './shared/Barcode';
// import Scanner from './shared/Barcode';
// import Q1Scanner from './shared/Barcode';
import Success from './components/Success';
import Failed from './components/Failed';
import Footer from './footer/Footer';
import { animateScroll } from 'react-scroll';

injectReducer('Website', reducer)

function Scroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    animateScroll.scrollToTop({
      duration: 0,
      smooth: 'easeInOutQuint'
    });
  }, [pathname]);

  return null;
}

function Root() {
  const dispatch = useDispatch();
  const selectedInstitucioni = useSelector((state) => state.Website.data.ManualetSelectedInsitucioni);

  const fetchLlojiPagesesManualet = async () => {
    try {
      const response = await getData(`Pagesat/GetLlojiPageses?institucioniId=${selectedInstitucioni.id}&sherbimiTipiId=7`);
      const options = response.data.map(({ id, emertimi }) => ({ label: emertimi, id: id }));
      dispatch(setLlojiPagesesManualet(options));
      dispatch(setManualetLlojiPagesesLoad(false));
    } catch (error) {
      dispatch(setLlojiPagesesManualet([]));
    }
  };

  const fetchInstitucioni = async () => {
    try {
      const response = await getData('Pagesat/MbushListenInstitucioni?SherbimiTipiID=7');
      const options = response.data.map(({ institutionId, name }) => ({ label: name, id: institutionId }));
      dispatch(setInstitucionet(options));
    } catch (error) {
      dispatch(setInstitucionet(null));
    }
  };

  useEffect(() => {
    fetchInstitucioni();
  }, []);

  useEffect(() => {
    fetchLlojiPagesesManualet();
  }, [selectedInstitucioni]);

  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navbarClasses = ['paysera-header'];

  if (scrolled) {
    navbarClasses.push('-scrolled');
  }

  return (
    <div className="site">
      <Router basename="/">
        <Scroll />
        {/* <header> */}
        <AppBar className={navbarClasses.join('')} position="sticky">
          <Navmenu />
        </AppBar>
        {/* </header> */}
        <div className="paysera-body">
          <Container maxWidth="lg">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/success" element={<Success />} />
              <Route exact path="/failed" element={<Failed />} />
              <Route exact path="/error" element={<Failed />} />
              <Route exact path="/payment" element={<PaymentFields />} />
              <Route exact path="/payment-others" element={<PaymentFieldsOthers />} />
              {/* <Route exact path="/barcode" element={<Q1Scanner />} /> */}
            </Routes>
          </Container>
        </div>
        <footer className="paysera-footer">
          <Footer />
        </footer>
      </Router>
    </div>

  );
}

export default Root;
